module.exports = __webpack_public_path__ + "media/bgm_main_en.eac750b0.aac";